import script from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"

import "./ProductSelector.vue?vue&type=style&index=0&id=5f253464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f253464"]])

export default __exports__